import { render, staticRenderFns } from "./SeuilResa.vue?vue&type=template&id=f6e163e8&"
import script from "./SeuilResa.vue?vue&type=script&lang=js&"
export * from "./SeuilResa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports